// extracted by mini-css-extract-plugin
export var container = "_d2-0";
export var icon = "_d2-1";
export var text = "_d2-2";